import type { ReactElement } from "react";

import type { TaskResponse } from "../features/queue/api";
import { useRerunTask } from "../features/queue/useRerunTask";
import { TaskActionButton } from "./TaskActionButton";
import type { TaskActionKeys } from "./TaskActionButton";

// Кнопка «Перезапустить». Используется в баннере escalated (рядом с
// cancel) и в секции «Действия» для cancelled-задачи.
// Поведение (409, ошибки, блокировка закрытия окна) — в TaskActionButton.
const KEYS: TaskActionKeys = {
  button: "task.rerunButton",
  inFlight: "task.rerunInFlight",
  confirmTitle: "task.rerunConfirmTitle",
  confirmBody: "task.rerunConfirmBody",
  confirmAccept: "task.rerunConfirmAccept",
  confirmReject: "task.rerunConfirmReject",
  errorTitle: "task.rerunErrorTitle",
};

export function RerunTaskButton({
  task,
}: {
  readonly task: TaskResponse;
}): ReactElement {
  const mutation = useRerunTask(task.id);
  return <TaskActionButton mutation={mutation} keys={KEYS} />;
}
